<template>
  <b-modal
    id="update-service-system-modal"
    cancel-variant="outline-secondary"
    :ok-title="$t('button.confirm')"
    :cancel-title="$t('button.close')"
    centered
    no-close-on-backdrop
    :title="$t('breadcrumb.updateServiceSystem')"
    :loading="loading"
    @ok="handleOk"
    @cancel="handleClose"
    @close="handleClose"
  >
    <template #modal-footer>
      <b-button
        variant="outline-secondary"
        class="btn"
        @click="handleClose"
      >
        {{ $t('button.close') }}
      </b-button>
      <n-button-loading
        :loading="loading"
        class="btn"
        variant="primary"
        @submit="handleOk"
      >
        {{ $t('button.confirm') }}
      </n-button-loading>
    </template>
    <validation-observer
      ref="updateServiceSystemForm"
    >
      <n-input
        v-model="data"
        :fields="formInput"
      >
        <template #customHoldDuration="item">
          <div v-if="data.holdDuration != 'custom'" />
        </template>
        <template #holdUntilDatetime="item">
          <b-form-group
            v-if="data.holdDuration === 'datetime'"
            :key="`holdUntilDatetime-${key}`"
            :label-for="item.field.key"
            :class="item.field.class"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t(item.field.label)"
              :rules="item.field.rules"
            >
              <label class="d-block">
                <span>{{ $t(item.field.label) }}</span>
              </label>
              <n-date-time-picker
                v-model="data.holdUntilDatetime"
                :placeholder="item.field.placeholder"
                :field="item.field"
                :disable-after-today="false"
                :disable-before-today="true"
                :class="errors.length > 0 ? 'is-invalid' : null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <div v-else />
        </template>
      </n-input>
    </validation-observer>
  </b-modal>
</template>

<script>
import { BModal, BButton, BFormGroup } from 'bootstrap-vue'
import NInput from '@/components/NInput.vue'
import useJwt from '@/auth/jwt/useJwt'
import NButtonLoading from '@/components/NButtonLoading.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import NDateTimePicker from '@/components/NDateTimePicker.vue'
import FormInput from './updateServiceSystemFormInput'

export default {
  components: {
    BModal,
    NInput,
    BButton,
    BFormGroup,
    NButtonLoading,
    NDateTimePicker,
  },
  props: {
    activeRoom: {
      type: Object,
      required: false,
      default() {
        return {}
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      data: {
        holdDuration: null,
        customHoldDuration: null,
        holdUntilDatetime: null,
        status: '',
        remark: '',
      },
      key: 1,
    }
  },
  computed: {
    userData() {
      return this.$store.state.profile.email || this.$store.state.profile.phone  
        ? this.$store.state.profile
        : JSON.parse(
          localStorage.getItem(useJwt.jwtConfig.storageUserDataKeyName),
        )
    },
  },
  methods: {
    show(status) {
      this.key += 1
      this.data = {
        holdDuration: null,
        customHoldDuration: null,
        holdUntilDatetime: null,
        status,
        remark: '',
      }
      this.$bvModal.show('update-service-system-modal')
    },
    hide() {
      this.$bvModal.hide('update-service-system-modal')
    },
    handleClose() {
      this.data = {
        holdDuration: null,
        customHoldDuration: null,
        holdUntilDatetime: null,
        status: '',
        remark: '',
      }
      this.hide()
      this.$emit('cancel')
    },
    calculateMinutesUntil(datetime) {
      if (!datetime) return null
      const now = new Date()
      const target = new Date(datetime)
      const diffMs = target - now
      const diffMinutes = Math.ceil(diffMs / (1000 * 60))
      return diffMinutes > 0 ? diffMinutes : null
    },
    handleOk(bvModal) {
      if (bvModal) bvModal.preventDefault()

      this.$refs.updateServiceSystemForm.validate().then(success => {
        if (success) {
          this.submit()
        }
      })
    },
    submit() {
      let noOfminuteHold
      if (this.data.holdDuration === 'custom') {
        noOfminuteHold = this.data.customHoldDuration
      } else if (this.data.holdDuration === 'datetime') {
        noOfminuteHold = this.calculateMinutesUntil(this.data.holdUntilDatetime)
        if (!noOfminuteHold) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('alert.error'),
              text: this.$t('alert.invalidHoldDurationDatetime'),
              variant: 'danger',
            },
          })
          return
        }
      } else {
        noOfminuteHold = this.data.holdDuration
      }

      this.$emit('update', noOfminuteHold, this.data.remark)
    },
  },
  setup() {
    const formInput = [...FormInput]

    return {
      formInput,
    }
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
